import { service } from '@/ajax/request'

export const getWsProductList = (params) => {
    return service({
        url: `/ws-product-init/get-page`,
        method: 'POST',
        params
    })
}

export const initWsProductList = (params) => {
    return service({
        url: `/ws-product-init/product-init`,
        method: 'POST',
        params
    })
}

export const initWsBlankProductList = (params) => {
    return service({
        url: `/ws-product-init/product-init-blank`,
        method: 'POST',
        params
    })
}

export const getWsStoreProductList = (params) => {
    return service({
        url: `/ws-product-init/get-product-page`,
        method: 'POST',
        params
    })
}

export const createWsStoreProduct = (params) => {
    return service({
        url: `/ws-product-init/create-or-update`,
        method: 'POST',
        params
    })
}

export const releaseStoreProduct = (params) => {
    return service({
        url: `/ws-product-init/release-product`,
        method: 'POST',
        params
    })
}

export const wsSymptom = (params) => {
    return service({
        url: `/ws-product-init/list-pres`,
        method: 'POST',
        params
    })
}

export const wsSymptomProductList = (params) => {
    return service({
        url: `/ws-product-init/list-by-pres`,
        method: 'POST',
        params
    })
}

export const wsSymptomAddProduct = (params) => {
    return service({
        url: `/ws-product-init/add-pres`,
        method: 'POST',
        params
    })
}

export const wsSymptomOneProductList = (params) => {
    return service({
        url: `/ws-product-init/list-by-pres`,
        method: 'POST',
        params
    })
}

export const wsSymptomOneProductDel = (params) => {
    return service({
        url: `/ws-product-init/delete-product-by-id`,
        method: 'POST',
        params
    })
}

export const wsProductHasBindMallProduct = (params) => {
    return service({
        url: `/ws-product-init/get-mall-product`,
        method: 'POST',
        params
    })
}
export const wsProductBindMallProduct = (params) => {
    return service({
        url: `/ws-product-init/add-spu`,
        method: 'POST',
        params
    })
}